<template>
  <page :title="i18n.title" background="#F8F6FC">
    <div class="help-center-warp">
      <div class="help-center-item" @click="goRouter('/guidePage')">
        <span>{{ i18n.user_guide }}</span>
        <img src="@/assets/imgs/icon_more.png" alt="">
      </div>
      <div class="help-center-item" @click="goRouter('/about')">
        <span>{{ i18n.contact_us }}</span>
        <img src="@/assets/imgs/icon_more.png" alt="">
      </div>
      <div class="help-center-bottom">
        <div class="help-center-contact">
          <div class="help-center-img" @click="onHref('tel:33775326267')">
            <img src="@/assets/imgs/icon_phone3.png" alt="">
          </div>
          <div @click="onHref('tel:33775326267')">{{ i18n.call_us }}</div>
        </div>
        <div class="help-center-contact">
          <div class="help-center-img" @click="onHref('mailto:direction@bscbini.fr')">
            <img src="@/assets/imgs/icon_email2.png" alt="">
          </div>
          <div @click="onHref('mailto:direction@bscbini.fr')">{{ i18n.send_email }}</div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
export default {
  computed: {
    i18n() {
      return this.$t("help")
    }
  },
  data() {
    return {
    }
  },
  methods: {
    goRouter(path) {
      this.$router.push(path)
    },
    onHref(path) {
      window.location.href = path
    }
  }
}
</script>

<style lang="less" scoped>
.help-center-warp {
  background: #F8F6FC;
  padding: 53px;
  height: calc(100vh - 194px);
  position: relative;
  .help-center-item {
    margin-bottom: 28px;
    height: 88px;
    background: #fff;
    border-radius: 18px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 28px;
    color: #000;
    img {
      width: 34px;
      height: 34px;
    }
  }
  .help-center-bottom {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 144px;
    display: flex;
    font-size: 35px;
    text-align: center;
    .help-center-contact {
      flex: 1;
      .help-center-img {
        width: 72px;
        height: 72px;
        padding: 23px;
        border-radius: 20px;
        background: rgba(255, 202, 14, 0.17);
        margin: 0 auto 40px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
